import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import Enum from '@square/dashboard-utilities/utils/enum';
export const SelectionType = new Enum('SINGLE', 'MULTIPLE');
export default ProtoBaseModel.extend({
  id: attr(String),
  name: attr(String),
  selectionType: attr(SelectionType)
});